import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { api } from '../../../lib/api'
import { Modal } from '../../../components/ui/Modal'
import { Button } from '../../../components/ui/Button'
import { StareLista } from '../../../components/ui/StareLista'
import { eroare } from './comun'

interface Om {
  id: number
  name: string
  email: string
}

/**
 * Cine validează și deblochează lunile colaborărilor. O alege un admin; nu e „orice admin”
 * (Mădălin, 04.11.2026). Cine e în listă vede toate colaborările, fără să le poată schimba.
 */
export function FereastraValidatori({ onInchide }: { onInchide: () => void }) {
  const qc = useQueryClient()
  const [alesi, setAlesi] = useState<Set<number> | null>(null)

  const echipa = useQuery({
    queryKey: ['echipa'],
    queryFn: async () => (await api.get<{ users: Om[] }>('/settings/users/echipa')).data.users,
  })
  const actuali = useQuery({
    queryKey: ['colaborari', 'validatori'],
    queryFn: async () =>
      (await api.get<{ validatori: Om[] }>('/colaborari/validatori')).data.validatori,
  })
  const bifati = alesi ?? new Set((actuali.data ?? []).map((v) => v.id))

  const salveaza = useMutation({
    mutationFn: async () => api.put('/colaborari/validatori', { userIds: [...bifati] }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['colaborari'] })
      toast.success('Lista validatorilor a fost salvată.')
      onInchide()
    },
    onError: (e) => toast.error(eroare(e)),
  })

  return (
    <Modal
      open
      onClose={onInchide}
      title="Cine validează lunile"
      footer={
        <>
          <Button variant="secondary" onClick={onInchide}>
            Renunță
          </Button>
          <Button onClick={() => salveaza.mutate()} loading={salveaza.isPending}>
            Salvează
          </Button>
        </>
      }
    >
      <p className="mb-3 text-sm text-b4l-text-muted">
        Cei bifați văd toate colaborările, validează și deblochează lunile. Nimeni nu își validează
        și nu își deblochează propria lună. Fiecare trebuie să aibă întâi pagina „Colaborări” din
        Setări → Acces. Nimeni nu se adaugă singur. Cât în listă e un administrator, lista o schimbă
        doar un administrator din ea.
      </p>
      <StareLista
        interogare={echipa.isLoading ? echipa : actuali}
        gol={!echipa.data?.length}
        mesajGol="Niciun cont activ."
      >
        <ul className="grid max-h-80 gap-1 overflow-y-auto text-sm">
          {(echipa.data ?? []).map((o) => (
            <li key={o.id}>
              <label className="flex items-center gap-2 py-0.5">
                <input
                  type="checkbox"
                  className="h-4 w-4"
                  checked={bifati.has(o.id)}
                  onChange={(e) => {
                    const n = new Set(bifati)
                    if (e.target.checked) n.add(o.id)
                    else n.delete(o.id)
                    setAlesi(n)
                  }}
                />
                {o.name}
                <span className="text-b4l-text-muted">{o.email}</span>
              </label>
            </li>
          ))}
        </ul>
      </StareLista>
    </Modal>
  )
}
